import {environment} from '../../environments/environment';

export class BaseService {
    protected baseUrl = environment.baseUrl;
    protected baseApiUrl = environment.baseApiUrl;
}



// WEBPACK FOOTER //
// ./src/app/base/service.base.ts